import React from 'react';
import { Divider, Stack, Typography } from '@mui/material';
import { useMediaDevice } from '@travelity/ui';

export interface ListTitleProps {
    children?: React.ReactNode;
    title?: string;
    filters?: React.ReactNode;
}

export const ListTitle: React.FC<ListTitleProps> = React.memo(
    (props: ListTitleProps) => {
        const { children, title, filters } = props;
        const { isMobile } = useMediaDevice();

        return (
            <>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    gap={1}
                    flexWrap={{ xs: 'wrap' }}
                    sx={{
                        py: 1.5,
                        height: '72px',
                    }}
                >
                    {title && (
                        <Typography
                            variant="h5"
                            sx={{ color: '#C0C4CE', whiteSpace: 'nowrap' }}
                        >
                            {title}
                        </Typography>
                    )}

                    <Stack
                        direction="row"
                        alignItems="center"
                        gap={1}
                        justifyContent={title ? 'flex-end' : 'flex-start'}
                    >
                        {children}
                        {isMobile && filters}
                    </Stack>
                </Stack>
                {filters && !isMobile && (
                    <>
                        <Divider
                            sx={{
                                mb: 0.25,
                                display: { xs: 'none', sm: 'block' },
                            }}
                        />
                        {filters}
                    </>
                )}
            </>
        );
    }
);
